import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { AccountRegisterSelectorComponent } from './account-register-selector.component';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MaterialSearchModule } from '../../../../shared/material-search/material-search.module';
import { CategorySelectModule } from '../../../accounting/chart-of-accounts/category-select/category-select.module';

@NgModule({
    imports: [
        SharedModule,
        MatIconModule,
        LFDropdownModule,
        MatAutocompleteModule,
        MatInputModule,
        MaterialSearchModule,
        CategorySelectModule,
    ],
    declarations: [AccountRegisterSelectorComponent],
    exports: [AccountRegisterSelectorComponent],
})
export class AccountRegisterSelectorModule
{
}
